import { useEffect, useRef, useState } from 'react';

// Keep a real image visible until playback starts. A video poster alone can
// be covered by iOS's native blocked-playback UI, especially in Low Power Mode.
export default function HeroAnimation() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    let disposed = false;
    video.muted = true;
    const attempt = video.play();
    attempt?.catch(() => {
      if (!disposed) setPlaying(false);
    });
    return () => { disposed = true; };
  }, []);

  return (
    <div className="home-hero-media" aria-hidden="true">
      <img
        src="/active_gaming_poster_red_v2.jpg"
        alt=""
        width="800"
        height="800"
      />
      <video
        ref={videoRef}
        className={playing ? 'is-playing' : ''}
        poster="/active_gaming_poster_red_v2.jpg"
        autoPlay
        loop
        muted
        playsInline
        controls={false}
        preload="auto"
        tabIndex={-1}
        onPlaying={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onError={() => setPlaying(false)}
      >
        <source src="/active_gaming_loop_red_v2.webm" type="video/webm" />
      </video>
    </div>
  );
}